import React from "react";
import { createUseStyles } from "react-jss";
import { ListCell } from "../..";
import { useTableContext } from "../../hooks/useTableContext";
import { classNames } from "../../utils/classNames";
import { SelectTableRowCheckbox } from "../SelectTableRowCheckbox";
import { getCellDataId, getCellDataTestId } from "../tableUtils";
import { DATA_COL_INDEX } from "../../utils/gridColumns";
export function TableRowActionAtStart(props) {
    const { rowIndex, item, form } = props;
    const classes = useTableActionClasses();
    const { isBulk } = useTableContext();
    const cellDataId = getCellDataId(rowIndex, props?.dataId);
    const cellDataTestId = getCellDataTestId(rowIndex, props?.dataTestId);
    return (React.createElement(ListCell, { className: classNames("table-atStart", classes.action), ariaColIndex: 1, role: "cell", dataId: cellDataId && `${cellDataId}-table-atStart`, dataTestId: cellDataTestId && `${cellDataTestId}-table-at-start` }, form?.values && form.labelIdentifier && form.idIdentifier && (React.createElement(SelectTableRowCheckbox, { label: item[form.labelIdentifier], name: form.name, id: item[form.idIdentifier], invert: isBulk }))));
}
const useTableActionClasses = createUseStyles({
    action: {
        gridArea: `${DATA_COL_INDEX}1`,
        paddingTop: 0,
        paddingRight: "0px!important",
        paddingLeft: 0,
        minHeight: 30,
        gridColumn: 1,
    },
});
